import React, { useEffect, useState } from "react";
import axios from "axios";
import "../../Styles/FacultyAttendanceToday.css";
import Loader from "../../Components/Loader";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

function FacultyAttendanceToday() {
  const [facultyAttendance, setFacultyAttendance] = useState([]);
  const [filteredAttendance, setFilteredAttendance] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [attendanceSummary, setAttendanceSummary] = useState({
    presentCount: 0,
    absentCount: 0,
  });

  useEffect(() => {
    const fetchTodayAttendance = async () => {
      try {
        const token = localStorage.getItem("authToken");
        if (!token) return;
        const summaryResponse = await axios.get(
          "https://api.uniums.com/api/admin/faculty-attendance-summary",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (summaryResponse.data) {
          setAttendanceSummary({
            presentCount: summaryResponse.data.presentCount,
            absentCount: summaryResponse.data.absentCount,
          });
        }

        const response = await axios.get(
          "https://api.uniums.com/api/admin/faculty-attendance-today",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data && response.data.data) {
          setFacultyAttendance(response.data.data);
          setFilteredAttendance(response.data.data);
        } else {
          setError("No attendance records found for today.");
        }
      } catch (err) {
        setError("Error fetching attendance records.");
      } finally {
        setLoading(false);
      }
    };

    fetchTodayAttendance();
  }, []);

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    setFilteredAttendance(
      facultyAttendance.filter(
        (faculty) =>
          faculty.name.toLowerCase().includes(query) ||
          faculty.employeeCode.toLowerCase().includes(query)
      )
    );
  };

  if (loading) return <Loader />;
  if (error) return <div className="error error_today">{error}</div>;

  return (
    <div className="faculty-attendance-today-container">
      <h1>Today's Faculty Attendance</h1>

      <div className="attendance-summary">
        <div className="attendance-summary-item present_box">
          <CheckCircleIcon className="today_svg" />
          <div className="present_box_count">
            <h3>Total Present : </h3>
            <h3>{attendanceSummary.presentCount}</h3>
          </div>
        </div>
        <div className="attendance-summary-item absent_box">
          <CancelIcon className="today_svg" />
          <div className="present_box_count">
            <h3> Total Absent :</h3>
            <h3>{attendanceSummary.absentCount}</h3>
          </div>
        </div>
      </div>

      <div className="search-bar">
        <input
          type="text"
          placeholder="Search by name or employee code..."
          value={searchQuery}
          onChange={handleSearch}
          className="search-box"
        />
      </div>

      <div className="faculty-table-container">
        {filteredAttendance.length > 0 ? (
          <table className="attendance-today-table">
            <thead>
              <tr>
                <th>Sl.</th>
                <th>Faculty Name</th>
                <th>Employee Code</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {filteredAttendance.map((faculty, index) => (
                <tr key={faculty._id}>
                  <td>{index + 1}</td>
                  <td>{faculty.name}</td>
                  <td>{faculty.employeeCode}</td>
                  <td
                    className={`attendanceStatus ${
                      faculty.attendanceStatus.toLowerCase() === "absent"
                        ? "absent"
                        : ""
                    }`}
                  >
                    {faculty.attendanceStatus}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="no-data-message">No data found today.</div>
        )}
      </div>
    </div>
  );
}

export default FacultyAttendanceToday;
